import React, { ReactElement, useEffect, useState } from 'react';
import { ImageCustom } from '../../common/components/ImageCustom';
import chargeDiamondIcon from '../../assets/svg/charge2.svg';
import { LiveFollowerList } from '../live-follower-list/LiveFollowerList';

import './CategoryPage.scss';
import { useDispatch } from 'react-redux';
import { showLoginModal } from '../login/login.slice';
import { showRegisterModal } from '../register/register.slice';
import { AuthState, useAuth } from '../auth/AuthProvider';
import {
  useGetListLiveMutation,
  useGetLiveCategoryListQuery,
} from '../../services/api/apiProvider';
import { LiveListCategory } from './component/LiveListCategory/LiveListCategory';
import { Link } from 'react-router-dom';
import { AiOutlineRight } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import { CategoryName } from './component/CategoryName/CategoryName';
import nothingLive from '../../assets/png/nothing_live.png';
import { useGetListFavoriteCategoryQuery } from '../../services/api/apiService/categoryApiService';
import { IResponseLive } from '../../services/api/models/response/responseLive';
import { Spinner } from 'react-bootstrap';
import { LiveBlock } from '../live/components/LiveBlock/LiveBlock';
import {
  IOptionGlobal,
  LeagueLiveType,
  LiveMaxDisplay,
  MethodLiveType,
  PathParams,
  VoiceLiveType,
} from '../../common/constants/globalConstants';
import { LiverLeague, LiverLeagueLevel } from '../top/models/liverLeague';
import { BlockGroup } from '../top/components/BlockGroup/BlockGroup';

export const CategoryPage = (): ReactElement => {
  const leaguesData: LiverLeague[] = [
    {
      name: '新人',
      type: 'rookies',
      isRookies: true,
      link: '/list/rookies',
    },
    {
      name: '一般',
      type: 'clover',
      level: LiverLeagueLevel.CLOVER_TWO,
      link: '/list/clover',
    },
  ];
  const { t } = useTranslation();
  const { isAuthenticated, isRegistering } = useAuth() as AuthState;
  const dispatch = useDispatch();
  const [liveList, setLiveList] = useState<IResponseLive[]>([]);
  const [loading, setLoading] = useState<boolean>();
  const [getListLive] = useGetListLiveMutation();
  const { data: listCategory } = useGetLiveCategoryListQuery();
  const { data: listFavoriteCategory } = useGetListFavoriteCategoryQuery();
  const [option, setOption] = useState<IOptionGlobal>({
    numOfPage: 0,
    numInPage: LiveMaxDisplay,
  });

  useEffect((): void => {
    // show login modal when user not login
    if (!isAuthenticated && !isRegistering) {
      dispatch(showLoginModal(true));
    }

    if (!isAuthenticated && isRegistering) {
      dispatch(
        showRegisterModal({
          visible: true,
        }),
      );
    }
  }, [isAuthenticated, isRegistering]);

  useEffect(() => {
    document.title = 'Web版everylive（エブリライブ）';
    getLiveListFavoriteData();
  }, []);

  if (!isAuthenticated) {
    return <></>;
  }
  const getLiveListFavoriteData = async () => {
    setLoading(true);
    const data = await getListLive({
      numOfPage: option.numOfPage,
      numInPage: option.numInPage,
      method: MethodLiveType.FAVORITE_CATEGORY,
      league: LeagueLiveType.ANY,
      voice: VoiceLiveType.ANY,
    }).unwrap();
    setLiveList(data);
    setLoading(false);
  };

  const renderList = () => {
    if (loading) {
      return (
        <div className="block-group__loading">
          <Spinner
            animation="border"
            style={{ color: 'var(--color-primary)' }}
          />
        </div>
      );
    }

    if (!liveList || liveList.length <= 0) {
      return (
        <div className="block-group__empty">
          <img src={nothingLive} alt="nothing-live" />
        </div>
      );
    }

    return liveList.map((live) => {
      return (
        <div key={live.id}>
          <LiveBlock live={live} />
        </div>
      );
    });
  };
  return (
    <div className="category-page-container">
      {/* <Carousel></Carousel> */}

      <div className="live-list-category-container">
        <div className="live-list-category-container__follower-list">
          <LiveFollowerList></LiveFollowerList>
        </div>

        <div className="live-list-category-container__live-list">
          {liveList.length > 0 && (
            <div className="live-list-category">
              <div className="live-list-category__header">
                <span className="live-list-category__header-title">
                  好きなカテゴリ
                </span>
                <div className="live-list-category__header-category-name">
                  {listFavoriteCategory?.map((favorite, index) => (
                    <CategoryName
                      key={index}
                      category={favorite}
                    ></CategoryName>
                  ))}
                </div>
                <div className="live-list-category__header-link">
                  <Link to={`/live-category/${PathParams.FAVORITE_CATEGORY}`}>
                    {t('More')}
                    <AiOutlineRight style={{ marginLeft: 5 }} />
                  </Link>
                </div>
              </div>
              <div className="live-list-category__body">{renderList()}</div>
            </div>
          )}

          {listCategory?.map((category, index) => (
            <LiveListCategory
              key={index}
              category={category}
            ></LiveListCategory>
          ))}
          {leaguesData?.map((league, index) => (
            <BlockGroup key={index} league={league}></BlockGroup>
          ))}
        </div>
      </div>

      <ImageCustom
        className="category-page__charge-button"
        src={chargeDiamondIcon}
        onClick={() => {
          window.open(process.env.REACT_APP_CHARGE_URL);
        }}
      ></ImageCustom>
    </div>
  );
};
